var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MqLayout',{attrs:{"mq":"md+"}},[_c('SearchResults')],1),_c('MqLayout',{attrs:{"mq":['sm', 'tsm']}},[_c('SearchResultsMobile')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }